import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SquareFootIcon from '@mui/icons-material/SquareFoot';
import Groups2Icon from '@mui/icons-material/Groups2';
import PublicIcon from '@mui/icons-material/Public';
import HandshakeIcon from '@mui/icons-material/Handshake';
import DomainIcon from '@mui/icons-material/Domain';
import HubIcon from '@mui/icons-material/Hub';
import StatisticCard from './StatisticCard';

const Statistics = () => {
  const { t } = useTranslation('home');

  const items = [
    { icon: DomainIcon, value: t('stats.projects.value'), label: t('stats.projects.label') },
    { icon: SquareFootIcon, value: t('stats.builtUpArea.value'), label: t('stats.builtUpArea.label') },
    { icon: Groups2Icon, value: t('stats.architects.value'), label: t('stats.architects.label') },
    { icon: HubIcon, value: t('stats.disciplineTeams.value'), label: t('stats.disciplineTeams.label') },
    { icon: HandshakeIcon, value: t('stats.clients.value'), label: t('stats.clients.label') },
    { icon: PublicIcon, value: t('stats.countries.value'), label: t('stats.countries.label') },
  ];

  const getItemSx = (idx) => {
    const isLastInRowXs = (idx + 1) % 2 === 0;
    const isLastInRowSm = (idx + 1) % 3 === 0;
    const isLastInRowMd = (idx + 1) % 6 === 0;

    const isLastRowXs = idx >= 4; // 6 items, 2 per row => last row starts at idx 4
    const isLastRowSm = idx >= 3; // 6 items, 3 per row => last row starts at idx 3

    return {
      p: 1.5,
      borderColor: 'divider',
      borderRight: {
        xs: isLastInRowXs ? 'none' : '1px solid',
        sm: isLastInRowSm ? 'none' : '1px solid',
        md: isLastInRowMd ? 'none' : '1px solid',
      },
      borderBottom: {
        xs: isLastRowXs ? 'none' : '1px solid',
        sm: isLastRowSm ? 'none' : '1px solid',
        md: 'none',
      },
      display: 'flex',
    };
  };

  return (
    <Box sx={{ mt: 2, mb: 4 }}>
      <Typography variant="h2" sx={{ mb: 2 }}>
        {t('statsLabel')}
      </Typography>
      <Grid container spacing={0}>
        {items.map((it, idx) => (
          <Grid item xs={6} sm={4} md={2} key={`stat-${idx}`} sx={getItemSx(idx)}>
            <StatisticCard icon={it.icon} value={it.value} label={it.label} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Statistics;

